import { Layout, Typography } from "antd";
import SocialMediaLinks from "../common/SocialMediaLinks";
import styles from "./index.module.less";

const { Header, Footer, Content } = Layout;
const { Title, Paragraph } = Typography;

const PrivacyPolicy = () => {
  return (
    <Layout className={styles["container"]}>
      <Header className={styles["header"]}>
        <div className={styles["logoText"]}>parkdux</div>
      </Header>

      <div className={styles["contentWrapper"]}>
        <Content>
          <Typography>
            <Title level={3}>Privacy Policy for parkdux - Car Parking App</Title>
            <Paragraph>
              <strong>Effective Date:</strong> 16-May-2025
            </Paragraph>
            <Paragraph>
              <strong>Last Updated:</strong> 16-May-2025
            </Paragraph>

            <Title level={4}>1. Introduction</Title>
            <Paragraph>parkdux ("we", "our", or "us") provides users with tools to find, reserve, and manage parking through our mobile application. We are committed to protecting your personal data and respecting your privacy.</Paragraph>
            <Paragraph>This Privacy Policy describes how we collect, use, and share information when you use our Android app.</Paragraph>

            <Title level={4}>2. Information We Collect</Title>
            <Paragraph>
              <strong>a. Personal Information</strong>
            </Paragraph>
            <ul>
              <li>Full name</li>
              <li>Phone number</li>
              <li>Email address (optional)</li>
              <li>Vehicle Number (e.g., license plate)</li>
            </ul>
            <Paragraph>
              <strong>b. Location Data</strong>
              <br />
              Real-time GPS location (only with user consent) to provide nearby parking options.
            </Paragraph>
            <Paragraph>
              <strong>c. Device Information</strong>
              <br />
              Push notification token
            </Paragraph>

            <Title level={4}>3. How We Use Your Information</Title>
            <Paragraph>We use your information to: </Paragraph>
            <ul>
              <li>Provide core features (e.g., locate and reserve parking for storage and retrieve of cars ..etc)</li>
              <li>Send booking confirmations, receipts, and alerts</li>
              <li>Respond to user inquiries or support requests</li>
              <li>Ensure compliance with legal obligations</li>
            </ul>

            <Title level={4}>4. Permissions We Request</Title>
            <Paragraph>Our app may request the following Android permissions: </Paragraph>
            <ul>
              <li>
                <strong>Location (ACCESS_FINE_LOCATION)</strong>: To show nearby parking spots and provide directions.
              </li>
              <li>
                <strong>Internet (INTERNET)</strong>: To access real-time parking availability.
              </li>
              <li>
                <strong>Network State (ACCESS_NETWORK_STATE)</strong>: To check internet connectivity.
              </li>
            </ul>
            <Paragraph>All permissions are requested with clear user consent.</Paragraph>

            <Title level={4}>5. How We Share Information</Title>
            <Paragraph>
              We <strong>do not sell</strong> your personal data.
            </Paragraph>

            <Title level={4}>6. Third-Party Services</Title>
            <Paragraph>
              We integrate third-party services such as Firebase. <br /> These third parties have their own privacy practices, which we recommend reviewing.
            </Paragraph>

            <Title level={4}>8. Data Security</Title>
            <Paragraph>We use industry-standard security practices including: </Paragraph>
            <ul>
              <li>RSA encryption</li>
              <li>Secure data storage</li>
              <li>Limited data access by authorized personnel only </li>
            </ul>

            <Title level={4}>9. Children’s Privacy</Title>
            <Paragraph>Our app is not intended for under the age of 18. We do not knowingly collect personal data from children.</Paragraph>

            <Title level={4}>10. Changes to This Policy</Title>
            <Paragraph>We may update this Privacy Policy from time to time. If we make material changes, we will notify you via app update or email.</Paragraph>

            <Title level={4}>11. Contact Us</Title>
            <Paragraph>
              📧 Email: it@wipropari.com
              <br />
              🌐 Website: www.wipropari.com
            </Paragraph>
          </Typography>
        </Content>

        <Footer className={styles["footer"]}>
          <div className={styles["footerFlex"]}>
            <div className={styles["poweredBy"]}>
              <span>Powered By</span>
              <img alt="logo" src={`${process.env.PUBLIC_URL}/assets/images/wipro-pari-logo.png`} />
            </div>
            <div className="gx-layout-footer-content">{`© parkdux. ${new Date().getFullYear()}-${(new Date().getFullYear() + 1).toString().slice(2)}`}</div>
            <SocialMediaLinks />
          </div>
        </Footer>
      </div>
    </Layout>
  );
};

export default PrivacyPolicy;
